module.exports = __webpack_public_path__ + "img/isceshi.32b6b930.png";